.container {
    display: flex;
    justify-content: center;
    align-content: center;
    margin: 100px 0;
}

.spinner {
    width: 120px;
    height: 120px;
    border: 8px solid #eeeeee;
    border-top-color: #cccccc;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .spinner {
        animation-duration: 4s;
    }
}
